const { MONDAY_LOGO_SRC, MONDAY_LOGO_WHITE_SRC, MONDAY_WELCOME_NEW_JOINERS_LOGO_SRC, NEW_BRAND_LOGO_SRC, NEW_BRAND_LOGO_WHITE_SRC, NEW_BRAND_WELCOME_NEW_JOINERS_LOGO_SRC, SMALL_MONDAY_LOGO_SRC, NEW_BRAND_SMALL_MONDAY_LOGO_SRC, OLD_BRAND_CTA_COLOR_NAMES, OLD_BRAND_CTA_HEX_COLORS, NEW_BRAND_CTA_COLOR_NAME, NEW_BRAND_CTA_HEX_COLOR } = require("../constants/brand");
// Only the monday.com logo itself is replaced. Any other src — an editor's "Override Logo Image", a
// cluster or product logo (monday CRM, monday dev...) — is its own brand decision and passes through.
// CommonJS with no ESM imports, so services/brand-service.test.js runs without a transform.
const NEW_BRAND_LOGO_BY_OLD_SRC = {
    [MONDAY_LOGO_SRC]: NEW_BRAND_LOGO_SRC,
    [MONDAY_LOGO_WHITE_SRC]: NEW_BRAND_LOGO_WHITE_SRC,
    [MONDAY_WELCOME_NEW_JOINERS_LOGO_SRC]: NEW_BRAND_WELCOME_NEW_JOINERS_LOGO_SRC,
    [SMALL_MONDAY_LOGO_SRC]: NEW_BRAND_SMALL_MONDAY_LOGO_SRC
};
const getBrandLogoSrc = (src, isNewBrand)=>isNewBrand && NEW_BRAND_LOGO_BY_OLD_SRC[src] || src;
const OLD_CTA_NAMES = new Set(OLD_BRAND_CTA_COLOR_NAMES);
const OLD_CTA_HEXES = new Set(OLD_BRAND_CTA_HEX_COLORS);
// A CTA's color name, black instead of purple on the new brand. Any other name passes through, and
// nothing changes while the brand is off, so callers can apply it unconditionally.
const getBrandCtaColorName = (colorName, isNewBrand)=>isNewBrand && OLD_CTA_NAMES.has(colorName) ? NEW_BRAND_CTA_COLOR_NAME : colorName;
// The same for components that pass a hex (the pricing cards' product colors).
const getBrandCtaHexColor = (hex, isNewBrand)=>isNewBrand && typeof hex === "string" && OLD_CTA_HEXES.has(hex.toLowerCase()) ? NEW_BRAND_CTA_HEX_COLOR : hex;
module.exports = {
    MONDAY_LOGO_WHITE_SRC,
    getBrandLogoSrc,
    getBrandCtaColorName,
    getBrandCtaHexColor
};
